import {
  UPDATE_OPPORTUNITIES_CURRENT_PAGE,
} from '../actionTypes';

let initialState = []

export default function opportunitiesCurrentPage(state = initialState, action) {
  switch(action.type) {
    case UPDATE_OPPORTUNITIES_CURRENT_PAGE:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/projectFinder/reducers/opportunitiesCurrentPage.js